(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WinesListHeaderController', WinesListHeaderController);

	WinesListHeaderController.$inject = ['$rootScope', '$scope', 'WineTable', 'focus', '$mdDialog'];

	function WinesListHeaderController($rootScope, $scope, WineTable, focus, $mdDialog) {

		/* jshint validthis: true */
		var self = this;

		self.table = WineTable;

		self.selectedFilter = WineTable.settings.selectedFilter;

		self.getFilters = WineTable.getFilters;

		self.resetPagination = WineTable.resetPagination;

		self.setFilter = setFilter;

		self.toggleSearch = toggleSearch;

		self.search = search;

		self.resetSearch = resetSearch;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

		}

		function toggleSearch(){
			self.searchToggle = self.table.toggleSearch();

			focus('searchToggled');
		}

		function setFilter(){
			WineTable.setFilter(self.selectedFilter);
		}

		function search(){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/search.html',
				controller: 'SearchDialogController as dialog'
			});
		}

		function resetSearch(){
			WineTable.resetAdvSearch();
		}
	}

})();
